import BaseModelAPI from '../BaseModelAPI';

export default class PurchaseRequest extends BaseModelAPI {
	static entity = 'purchaserequest';
	static entityName = 'purchaserequest';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.purchaseRequestNumber = '';
		this.partClassificationId = '';
		this.partClassification = {};
		this.vendorId = '';
		this.vendor = {};
		this.totalQty = 0;
		this.revisi = 0;
		this.purchaseOrderNumber = '';
		this.purchaseRequestStatusId = '';
		this.purchaseRequestStatus = '';
		this.purchaseRequestDate = '';
		this.deliveryDate = '';
		this.remark = '';
		this.purchaseRequestDetail = []
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async PrintPR(this_, id) {
		let _this = this_;
		return this_.$http.get(`${this.entityName}/printPdfPR/${id}`)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

}